// Petit helper d'effets ludiques (confettis + easter eggs)
import confetti from 'canvas-confetti';

// Confetti "succès" (rouge/blanc — palette Code Voiture)
export function celebrate() {
  try {
    const colors = ['#dc2626', '#ffffff', '#ef4444', '#fbbf24'];
    // Burst gauche
    confetti({
      particleCount: 55,
      spread: 65,
      angle: 60,
      origin: { x: 0.15, y: 0.85 },
      colors,
      scalar: 0.9,
      startVelocity: 45,
      gravity: 0.9,
      ticks: 180,
    });
    // Burst droit
    confetti({
      particleCount: 55,
      spread: 65,
      angle: 120,
      origin: { x: 0.85, y: 0.85 },
      colors,
      scalar: 0.9,
      startVelocity: 45,
      gravity: 0.9,
      ticks: 180,
    });
  } catch { /* silently ignore */ }
}

// Petit "sparkle" plus discret (pour copier une leçon)
export function sparkle() {
  try {
    confetti({
      particleCount: 20,
      spread: 40,
      angle: 90,
      origin: { x: 0.5, y: 0.7 },
      colors: ['#10b981', '#34d399', '#ffffff'],
      scalar: 0.7,
      startVelocity: 25,
      gravity: 1.1,
      ticks: 120,
    });
  } catch { /* silently ignore */ }
}
